/** Servis fişi iskonto satırı kalem tipi */
export const SERVICE_ORDER_ITEM_TYPE_DISCOUNT = 4;

/** Form / API satırları (Partial alanlar dahil) */
export type ServiceOrderLineLike = {
  itemType?: number;
  totalPrice?: number;
  taxRate?: number;
};

export function isDiscountLine(line: { itemType?: number }): boolean {
  return line.itemType === SERVICE_ORDER_ITEM_TYPE_DISCOUNT;
}

export function getBusinessLines<T extends { itemType?: number }>(lines: T[]): T[] {
  return lines.filter((l) => !isDiscountLine(l));
}

export function getDiscountLine<T extends { itemType?: number }>(lines: T[]): T | undefined {
  return lines.find((l) => isDiscountLine(l));
}

/**
 * Satırın KDV dahil tutarı.
 * İskonto satırında totalPrice zaten KDV dahil indirim tutarıdır (negatif); üzerine KDV eklenmez.
 */
export function lineGrossAmount(line: ServiceOrderLineLike): number {
  const net = line.totalPrice || 0;
  if (isDiscountLine(line)) {
    return net;
  }
  return net * (1 + (line.taxRate ?? 20) / 100);
}

/** İskonto satırı KDV sütunu (gösterim) */
export function lineTaxRateDisplay(line: ServiceOrderLineLike): number {
  return isDiscountLine(line) ? 0 : (line.taxRate ?? 20);
}

/** İskonto hariç KDV dahil ara toplam */
export function calcGrossBeforeDiscount(lines: ServiceOrderLineLike[]): number {
  return getBusinessLines(lines).reduce((sum, line) => sum + lineGrossAmount(line), 0);
}

/** Tüm satırlar dahil KDV dahil genel toplam */
export function calcGrossTotal(lines: ServiceOrderLineLike[]): number {
  return lines.reduce((sum, line) => sum + lineGrossAmount(line), 0);
}

export function calcNetTotal(lines: ServiceOrderLineLike[]): number {
  return lines.reduce((sum, line) => sum + (line.totalPrice || 0), 0);
}

export function calcVatAmount(lines: ServiceOrderLineLike[]): number {
  return calcGrossTotal(lines) - calcNetTotal(lines);
}

/** İskonto satırı: KDV dahil indirim tutarı (pozitif sayı) */
export function getDiscountGrossAmount(line: ServiceOrderLineLike | undefined): number {
  if (!line || !isDiscountLine(line)) return 0;
  return Math.abs(line.totalPrice || 0);
}

export function hasOrderDiscount(lines: ServiceOrderLineLike[]): boolean {
  return getDiscountGrossAmount(getDiscountLine(lines)) > 0;
}
